import React from 'react'
import bgImage from '../../assets/servicesImages/appdev/hero.png'
import AppDevSection2 from '../../Pages/AppDevSection2'
import AppDevSection3 from '../../Pages/AppDevSection3'
import bottomImage from '../../assets/servicesImages/appdev/bottom.png'

const AppDev = () => {
    return (
        <div className='flex flex-col gap-[64px]'>

            {/* Hero Section */}
            <div
  className='w-full text-white flex justify-center items-center pt-24 relative bg-cover bg-center
             h-[40vh] sm:h-[40vh] md:h-[40vh] lg:h-screen'
  style={{ backgroundImage: `url(${bgImage})` }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-[rgba(0,0,0,0.4)] z-0"></div>

  {/* Content */}
  <div className='flex flex-col items-center gap-6 px-6 sm:px-10 md:px-12 z-10 text-center'>
    <p className='font-nunito font-extrabold text-[32px] sm:text-[44px] md:text-[60px] leading-tight'>
      Application Development
    </p>
    <p className="text-[14px] sm:text-[16px] md:text-[18px] leading-relaxed sm:leading-[26px] md:leading-[28px] max-w-[700px] mx-auto">
      We are leading the way in mobile app development for iOS, Android, and hybrid platforms. Our team specializes in creating seamless, engaging, and user-focused applications tailored to your business needs.
    </p>
  </div>
</div>


            {/* Text Section */}
            <div className='flex flex-col gap-[40px] px-6 sm:px-8 md:px-12 lg:px-64'>
    <p className='text-center font-nunito text-[24px] sm:text-[30px] md:text-[36px] font-semibold'>
        Driving Digital Transformation with Mobile Apps
    </p>
    <p className='font-nunito text-[16px] sm:text-[18px] md:text-[20px] font-medium leading-[24px] sm:leading-[28px] md:leading-[32px] text-justify'>
        Mobile apps are the backbone of modern businesses, driving digital transformation and increasing customer engagement. eSparse Matrix Solutions Pvt. Ltd. offers innovative and cost-effective mobile app development services that provide seamless user experiences and help grow your brand’s reach.
    </p>
</div>

            {/* Additional Sections */}
            <AppDevSection2 />
            <AppDevSection3 />

            {/* Bottom Image Section */}
            <div className='flex justify-center pb-24'>
                <img src={bottomImage} alt='bottom' className='w-full max-w-[1200px] h-auto' />
            </div>
        </div>
    )
}

export default AppDev
